module.exports = {
  "container": {
    "position": "fixed",
    "width": 750,
    "zIndex": 99999
  },
  "wxc-mask": {
    "position": "fixed",
    "top": 300,
    "left": 60,
    "width": 702,
    "height": 800
  },
  "mask-bottom": {
    "width": 100,
    "height": 100,
    "backgroundColor": "rgba(0,0,0,0)",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "mask-close-icon": {
    "width": 64,
    "height": 64
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6eb51d3e!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-mask/index.vue
// module id = 144
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28